var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    { attrs: { action: _vm.exportToGoogle, method: "POST", target: "_blank" } },
    [
      _c("c-button", {
        attrs: {
          type: "submit",
          icon: {
            icon: "google",
            color: "green",
          },
          label: "Выгрузить в Google таблицы",
          responsive: "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }